import {nzLocal,fromNZ} from '../phases/model';
export const taskDateNZ=(iso:string|null)=>!iso?'':/^\d{4}-\d{2}-\d{2}$/.test(iso)?iso:nzLocal(iso).slice(0,10);
export function preserveTaskTimeOnDateChange(old:string|null,date:string){
 if(!date)return null;
 if(!/^\d{4}-\d{2}-\d{2}$/.test(date))throw Error('Choose an NZ calendar date');
 if(old&&taskDateNZ(old)===date)return old;
 const local=date+'T'+(old?nzLocal(old).slice(11,16):'00:00');
 const base=fromNZ(local),prior=old?new Date(old):null;
 return new Date(Date.parse(base)+(prior?prior.getUTCSeconds()*1000+prior.getUTCMilliseconds():0)).toISOString();
}
